<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0.1" stepTitle="套餐及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">商品详情</span>
            </a-col>
          </a-row>
          <p class="tips">如果上传本地图片，图片大小应小于1M，图片格式为.jpg .png。建议商品详情中填写签证所需资料信息</p>
          <CustomUeditor v-model="visaDetails"></CustomUeditor>
          <a-row style="margin-top:20px;">
            <a-button type="primary" :disabled="proSource!=0" @click="submitData" :loading="submitLoading">
              提交并下一步
            </a-button>
            <a-button v-if="proId!=0" @click="goEvent" style="margin-left: 10px">下一步</a-button>
          </a-row>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import PublishPro from '../components/PublishPro'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'

export default {
  name: 'VisaProDes',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro,
    CustomUeditor
  },
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      visaDetails: '',
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: ''
    }
  },
  mounted() {
    this.getProVisaDes()
  },
  methods: {
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getProService().post('visa/saveProVisaDes', {
        proId: this.proId,
        visaDetails: this.visaDetails
      }).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('商品详情保存成功')
        setTimeout(() => {
          this.goEvent()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getProVisaDes() {
      this.getHttpServices().getProService().get('visa/getProVisaDes/' + this.proId).then(res => {
        // this.getLogUtils().logWithTag("getProVisaDes",res)
        this.visaDetails = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goEvent() {
      this.$router.push({
        name: 'OptionList',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>